const getDatapointAndRemaining = (dimension, datapoints) => {
    const result = { dimDp: undefined, remaining: [] };
    for (const dp of datapoints ?? []) {
        if (dp.name === dimension) {
            result.dimDp = dp;
        }
        else {
            result.remaining.push(dp);
        }
    }
    return result;
};
const mapVisitablesByDimension = (visitables, dimension) => {
    const map = new Map();
    for (const visitable of visitables) {
        for (const series of visitable?.series ?? []) {
            const { dimDp, remaining } = getDatapointAndRemaining(dimension, series.datapoints);
            if (dimDp) {
                const key = String(dimDp.value ?? "");
                if (!map.has(key)) {
                    map.set(key, { datapoints: [], value: dimDp.value });
                }
                map.get(key)?.datapoints.push(...remaining);
            }
        }
    }
    return map;
};
const fullOuterMergeByDimension = (visitables, dimension) => {
    const baseSeries = visitables[0].series?.map((series) => ({ ...series })) || [];
    const map = mapVisitablesByDimension(visitables.slice(1), dimension);
    const matchedKeys = new Set();
    for (const series of baseSeries) {
        const dimDp = series.datapoints?.find((dp) => dp.name === dimension);
        if (dimDp) {
            const key = String(dimDp.value ?? "");
            const entry = map.get(key);
            series.datapoints = [...series.datapoints ?? [], ...entry?.datapoints ?? []];
            matchedKeys.add(key);
        }
    }
    const baseDate = baseSeries[0]?.date;
    const unmatchedSeries = [...map.entries()]
        .filter(([key]) => !matchedKeys.has(key))
        .map(([, entry]) => ({
        datapoints: [{ name: dimension, value: entry.value }, ...entry.datapoints],
        ...baseDate ? { date: baseDate } : {}
    }));
    visitables[0] = { ...visitables[0], series: [...baseSeries, ...unmatchedSeries] };
};
export const mergeDatapointsFromDifferentRequestVisitor = () => (args) => {
    const visitables = [...args.visitable].sort((a, b) => ((a?.id || 1) > (b?.id || 0) ? 1 : -1));
    const { arguments: argsList } = args.context.config?.[0] || {};
    if (argsList) {
        fullOuterMergeByDimension(visitables, argsList[0]);
    }
    args.visitable = [visitables?.[0]];
};
